import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Product from "./pages/Product";
import About from "./pages/other/About";
import Cart from "./pages/other/Cart";
import Connect_Us from "./pages/other/Connect_Us";
import NotFound from "./pages/other/NotFound";
import ScrollToTop from "./helpers/scroll-top";
import MyOrders from "./pages/dashboard/Orders";
import ProtectedRoute from "./wrappers/ProtectedRoute";
import OrderSuccess from "./pages/order/OrderSuccess";
import BlogNoSidebar from "./pages/blog/BlogNoSidebar";
import BlogStandard from "./pages/blog/BlogStandard";
import BlogRightSidebar from "./pages/blog/BlogRightSidebar";
import BlogDetailsStandard from "./pages/blog/BlogDetailsStandard";
import Category from "./pages/category/Category";
import Collection from "./pages/category/collection/Collection";
import OrderDetail from "./pages/order/OrderDetail";
import TermsCondition from "./pages/footerPages/TermsCondition";
import OurPolicy from "./pages/footerPages/OurPolicy";
import PrivacyPolicy from "./pages/footerPages/PrivacyPolicy";
import ShippingPolicy from "./pages/footerPages/ShippingPolicy";
import ReturnPolicy from "./pages/footerPages/ReturnPolicy";
import CancellationPolicy from "./pages/footerPages/CancellationPolicy";
import Search from "./pages/Search";
import { PartnerProvider } from "./helpers/BrandPageAPI";
import "./index.css";
import "./assets/css/mobile.css";

const routes = [
  { path: "/:UserCode", element: <Home /> },
  { path: "/:UserCode/product/:id", element: <Product /> },
  { path: "/:UserCode/category/:id", element: <Category /> },
  { path: "/:UserCode/collection/:id", element: <Collection /> },
  { path: "/:UserCode/connectUs", element: <Connect_Us /> },
  { path: "/search", element: <Search /> },
  { path: "/orders", element: <ProtectedRoute element={<MyOrders />} /> },
  { path: "/order-success", element: <ProtectedRoute element={<OrderSuccess />} /> },
  { path: "/order/:id", element: <ProtectedRoute element={<OrderDetail />} /> },
  { path: "/:UserCode/cart", element: <Cart /> },
  { path: "/terms-condition", element: <TermsCondition /> },
  { path: "/our-policy", element: <OurPolicy /> },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/shipping-policy", element: <ShippingPolicy /> },
  { path: "/return-policy", element: <ReturnPolicy /> },
  { path: "/cancellation-policy", element: <CancellationPolicy /> },
  { path: "/blog-no-sidebar", element: <BlogNoSidebar /> },
  { path: "/blog/:UserCode", element: <BlogNoSidebar /> },
  { path: "/blog-standard", element: <BlogStandard /> },
  { path: "/blog-right-sidebar", element: <BlogRightSidebar /> },
  { path: "/blog-details-standard", element: <BlogDetailsStandard /> },
  { path: "/not-found", element: <NotFound /> },
  { path: "*", element: <NotFound /> },
];

const App = () => {

  return (
    <Router>
      <PartnerProvider>
        <ScrollToTop>
          <Routes>
            {routes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
          </Routes>
        </ScrollToTop>
      </PartnerProvider>
    </Router>
  );
};

export default App;
